import React from "react";

function Rss({ small }) {
  return (
    <svg
      className="inline"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      width={small ? "16px" : "24px"}
      height={small ? "16px" : "24px"}
    >
      <rect fill="currentColor" width="8" height="8" rx="1.5" />
      <circle fill="white" cx="2" cy="6" r="1" />
      <path fill="white" d="m 1,4 a 3,3 0 0 1 3,3 h 1 a 4,4 0 0 0 -4,-4 z" />
      <path fill="white" d="m 1,2 a 5,5 0 0 1 5,5 h 1 a 6,6 0 0 0 -6,-6 z" />
    </svg>
  );
}

export default Rss;
